<div class="app-sidebar" [ngClass]="{ 'collapsed': collapsed }">
  <ul class="app-sidebar__options">
    <li *ngFor="let option of availableOptions; let i = index">
      <a [routerLink]="option.link" routerLinkActive="active" (click)="getRoute(option.link)" >
        <i class="material-icons" [title]="option.label">{{ option.icon }}</i>
        <span>{{ option.label }}</span>
      </a>
      <div class="app-sidebar--separator" *ngIf="i === separatorPosition"></div>
    </li>
  </ul>
</div>
